<template>
    <div>
        <div v-if="pageLoader">
            <PageLoader></PageLoader>
        </div>
        <div v-else class="container-fluid">
            <div class="top-control">
                <button class="btn" :class="[activeNav == 1 ? 'active-control' : '']" @click="activeNav = 1">My Safe</button>
                <button class="btn" :class="[activeNav == 2 ? 'active-control' : '']" @click="activeNav = 2">Account Details</button>
            </div>
            <div v-if="activeNav == 1">
                <div class="row mt-3">
                    <div class="col-md-4">
                        <div class="safe-card mb-3">
                            <div class="safe-card-top">
                                <div class="" style="display: flex; gap: 10px;">
                                    <img src="../assets/icons/safe-logo-black.svg" alt="safe">
                                    <h3>SAFE</h3>
                                </div>
                                <div>
                                    <button class="btn primaryBtn" @click="widthdrawFromSafeTrigger()">Withdraw</button>
                                </div>
                            </div>
                            <p class="af">Available funds</p>

                            <div class="safe-amount">
                                <div class>
                                    <h3><span class="naira" v-if="amountVisibility">₦</span>{{ amountVisibility ? Number(safeDetails.balance).toLocaleString() : '**************'}}  <span @click="amountVisibility = !amountVisibility"><i class="fa" style="cursor: pointer;" :class="[amountVisibility ? 'fa-eye-slash' : 'fa-eye']"></i></span></h3>
                                    <p v-if="newDasboard.data.safe_last_funded != null">last funded: <span>{{ newDasboard.data.safe_last_funded.created_at | moment }}</span></p>
                                    <div class="increase-figure">
                                        <span>{{newDasboard.data.percentage_increase}}%</span> <span><i class="fa fa-arrow-up"></i></span>
                                    </div>
                                </div>
                                <!-- <div>
                                    <small class="triggerWithdraw" @click="widthdrawFromSafeTrigger()">Withdraw</small>
                                </div> -->
                            </div>

                            <!-- v-if="whichSafe == 'yellowSafe'" -->
                            <div class="bank-details" v-if="whichSafe != 'blue'"> 
                                <div class="account-number" v-if="(safeDetails.safedata.squadaccountno != null && safeDetails.safedata.firstBankaccountNumber == null) || (safeDetails.safedata.squadaccountno == null && safeDetails.safedata.firstBankaccountNumber != null)">
                                <!-- <div class="account-number" v-if="currentAccountDetails"> -->
                                    <img v-if="currentAccountDetails.bank_name == 'gtb'" src="../assets/icons/banks-logo.svg" alt="bank">
                                    <img style="width: 36px;"  v-if="currentAccountDetails.bank_name == 'fbn'" src="../assets/icons/fbn-logo.svg" alt="bank">
                                    <div>
                                        <p v-if="currentAccountDetails.bank_name == 'gtb'">GT Bank</p>
                                        <p v-if="currentAccountDetails.bank_name == 'fbn'">First Bank</p>
                                        <h5>{{ currentAccountDetails.account_number }} <span @click="copyAccountNumber(currentAccountDetails.account_number)"><img class="pl-2" style="cursor: pointer;" src="../assets/icons/bx-copy.svg" alt="copy"></span></h5>
                                    </div>
                                </div>
                                <div v-else></div>
                                <div>
                                    <!-- <button type="button" class="btn btn-primary" data-toggle="button" aria-pressed="false" autocomplete="off">
                                        On/Off
                                    </button> -->

                                    <div class="d-flex align-items-center" v-if="safeDetails.safedata.firstBankaccountNumber !== null && safeDetails.safedata.squadaccountno !== null">
                                        <!-- <label for="">Switching</label> -->
                                        <label for="customSwitch1" class="mb-0 mr-2 swicthbank-text"><span class="d-none d-sm-block">Switch to </span>  {{ switchState ? 'GT' : 'First' }} bank</label>
                                        <div class="custom-control custom-switch">
                                            <input :disabled="switching" type="checkbox" class="custom-control-input" id="customSwitch1" v-model="switchState" @change="switchAccount()">
                                            <label class="custom-control-label" for="customSwitch1"></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <div class="" style="background: #ffffff; padding: 15px; border-radius: 12px;">
                            <h5 class="chart-headersss">Safe Transactions</h5>
                            <apexchart type="line" height="180" :options="chartOptions" :series="series"></apexchart>
                        </div>
                    </div>
                </div>

                <div class="table-holder">
                    <h4 class="t-history">Transaction History</h4>

                    <div v-if="transactions.length <= 0" class="empty-state mt-5 mb-5">
                        <img src="../assets/icons/emptycan-state.svg" alt="empty">
                        <h5>No available data</h5>
                    </div>
                    <div v-else class="table-responsive tableList">
                        <!-- <table class="table" v-if="!loadingDashboard && assingedFMArray.length != 0"> -->
                            <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col">Date</th>
                                    <th scope="col">Time</th>
                                    <th scope="col">Description</th>
                                    <th scope="col">Type</th>
                                    <th scope="col">Channel</th>
                                    <th scope="col">Amount</th>
                                    <th scope="col">Status</th>
                                </tr>
                            </thead>
                            <tbody v-for="(data, index) in transactions" :key="index">
                                <!-- v-for="(item, index) in landlords"
                                    :key="index" -->
                                <tr>
                                    <td>{{data.created_at | moment2}}</td>
                                    <td>{{data.created_at | moment3}}</td>
                                    <td>{{data.description}} </td>
                                    <td>Rent</td>
                                    <td>{{data.channel}}</td>
                                    <td>₦{{ Number(data.amount).toLocaleString() }}</td>
                                    <td><span :class="[data.type == 'credit' ? 'credit' : 'debit']" class="">{{data.type}}</span></td>
                                </tr>   
                        
                            </tbody>
                        </table>
                        <!-- <div v-if="landlords.length == 0 && !loadingLandlord">
                            <EmptyState :emptyData="emptyDataObject2" />
                        </div> -->
                    </div>

                </div>
            </div>

            <div v-if="activeNav == 2">
                <div class="withdrawal-account-section">
                    <h6>Withdrawal Account information</h6>

                    <div class="withdrawal-account-section" v-if="userAccounts.length > 0">
                        <div class="account-holder" v-for="(item, index) in userAccounts" :key="index">
                            <div class="row">
                                <div class="col-md-4">
                                    <div>
                                        <h4>Bank Name</h4>
                                        <h5>{{item.bank_name}}</h5>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <h4>Account Number</h4>
                                    <h5>{{item.account_number}}</h5>
                                </div>
                                <div class="col-md-4">
                                    <h4>Account Name</h4>
                                    <h5>{{item.account_name}}</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    
                    <div v-else class="empty-state mt-5 mb-5">
                        <img src="../assets/icons/emptycan-state.svg" alt="empty">
                        <h5>No available data</h5>
                    </div>

                    <div class="modal" tabindex="-1" id="addaccount">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title modal-top">Add Account</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <!-- <div class="form-group">
                                        <label for="destination">Bank</label>
                                        <select class="form-control" id="destination" v-model="bankinfo">
                                            <option value="" selected disabled>Select bank</option>
                                            <option v-for="(item, index) in banknameandcode" :key="index" :value="item">{{item.bank_name}}</option>
                                            
                                        </select>
                                    </div> -->

                                    <div class="form-group">
                                        <div class="dropdownn">
                                            <!-- Dropdown toggle -->
                                            <div class="dropdown-togglee" @click="toggleDropdown()">
                                            {{ selected || "Select bank" }}
                                            </div>

                                            <!-- Dropdown menu -->
                                            <div v-if="isOpen" class="dropdown-menuu">
                                            <!-- Search input -->
                                                <input
                                                    name="search"
                                                    type="text"
                                                    v-model="search"
                                                    placeholder="Filter by bank name"
                                                    class="dropdown-search"
                                                />

                                                <!-- List of filtered items -->
                                                <ul class="dropdown-list">
                                                    <li
                                                    v-for="(item, index) in filteredItems"
                                                    :key="index"
                                                    @click="selectItem(item)"
                                                    class="dropdown-item"
                                                    >
                                                    {{ item.bank_name }}
                                                    </li>
                                                    <li v-if="filteredItems.length === 0" class="no-results">
                                                    No matches found
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- <div class="form-group">
                                        <label for="bank">Bank name</label>
                                        <input type="text" class="form-control" id="bank" placeholder="Bank name" v-model="bankname">
                                    </div> -->
                                    
                                    <div class="form-group">
                                        <label for="accountnumber">Account number</label>
                                        <input type="text" class="form-control" id="accountnumber" placeholder="Account number" v-model="accountnumber">
                                    </div>
                                    <div class="form-group" v-if="accountname != ''">
                                        <label for="acountname">Account name</label>
                                        <input disabled type="text" class="form-control" id="accountname" placeholder="Account name" v-model="accountname">
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> -->
                                    <button :disabled="loadingaccount" v-if="!letsvalidate" type="button" class="btn primaryBtn" @click="validateAccountNumber()">
                                        Verify Account
                                        <span v-if="loadingaccount"><i class="fa fa-spinner fa-spin ml-3 f-12"></i></span>
                                    </button>
                                    <button type="button" v-if="letsvalidate" class="btn white-outline-btn" data-dismiss="modal" aria-label="Close" @click="afteraction()">
                                        Cancel
                                    </button>
                                    <button :disabled="loadingaddAccount" type="button" v-if="letsvalidate" class="btn primaryBtn" @click="addAccountNumber()">
                                        Add Account
                                        <span v-if="loadingaddAccount"><i class="fa fa-spinner fa-spin ml-3 f-12"></i></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="bank-addition">
                        <button :disabled="userAccounts.length >= 2" class="btn" @click="openAddAcountModal()">Add new withdrawal account</button>
                    </div>
                </div>


                <div class="withdrawal-account-section">
                    <h6>Safe Account Information</h6>

                    <!-- For GTB SQUARD -->
                    <div class="account-holder" v-if="safeDetails.safedata.squadaccountno != null">
                        <div class="row">
                            <div class="col-md-4">
                                <div>
                                    <h4>Bank Name</h4>
                                    <h5>GTB Bank</h5>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <h4>Account Number</h4>
                                <h5>{{safeDetails.safedata.squadaccountno}}</h5>
                            </div>
                            <div class="col-md-4">
                                <h4>Account Name</h4>
                                <h5>{{safeDetails.safedata.last_name}}</h5>
                            </div>
                        </div>
                    </div>
                    <!-- For GTB SQUARD -->

                    <!-- For FBN VIRTUAL ACCOUNT -->
                    <div class="account-holder" v-if="safeDetails.safedata.firstBankaccountNumber != null">
                        <div class="row">
                            <div class="col-md-4">
                                <div>
                                    <h4>Bank Name</h4>
                                    <h5>First Bank</h5>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <h4>Account Number</h4>
                                <h5>{{safeDetails.safedata.firstBankaccountNumber}}</h5>
                            </div>
                            <div class="col-md-4">
                                <h4>Account Name</h4>
                                <h5>{{safeDetails.safedata.first_bank_account_name}}</h5>
                            </div>
                        </div>
                    </div>
                    <!-- For FBN VIRTUAL ACCOUNT -->

                    <div v-if="safeDetails.safedata.squadaccountno == null && safeDetails.safedata.firstBankaccountNumber == null" class="empty-state mt-5 mb-5">
                        <img src="../assets/icons/emptycan-state.svg" alt="empty">
                        <h5>No available safe account</h5>
                    </div>

                    <div class="bank-addition" v-if="safeDetails.safedata.firstBankaccountNumber == null">
                        <button class="btn" @click="openAddFBNAcountModal()">Add First bank account</button>
                    </div>
                    <!-- <div class="bank-addition" v-if="safeDetails.safedata.squadaccountno == null">
                        <button class="btn" @click="openAddFBNAcountModal()">Add GT bank account</button>
                    </div> -->

                    <div class="modal" tabindex="-1" id="addaFBNccount">
                        <div class="modal-dialog">
                            <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title modal-top">Add First Bank Account</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="container-fluid">
                                <!-- <div class="form-group">
                                    <label for="destination">Bank</label>
                                    <select class="form-control" id="destination" v-model="bankinfo">
                                        <option value="" selected disabled>Select bank</option>
                                        <option v-for="(item, index) in banknameandcode" :key="index" :value="item">{{item.bank_name}}</option>
                                        
                                    </select>
                                </div> -->
                                <div v-if="!validBvn">
                                    <div class="form-group">
                                        <label for="bvnfbn">BVN</label>
                                        <input type="number" class="form-control" id="bvnfbn" placeholder="Enter your BVN" v-model="bvnfbn">
                                    </div>
                                </div>
                                <div v-if="validBvn">
                                    <div class="form-group">
                                        <label for="firstnamefbn">First name</label>
                                        <input disabled="text" class="form-control" id="firstnamefbn" placeholder="First name" v-model="firstnamefbn">
                                    </div>
                                    <div class="form-group">
                                        <label for="lastnamefbn">Last name</label>
                                        <input disabled type="text" class="form-control" id="lastnamefbn" placeholder="Last name" v-model="lastnamefbn">
                                    </div>
                                    <div class="form-group">
                                        <label for="emailfbn">Email</label>
                                        <input disabled type="email" class="form-control" id="emailfbn" placeholder="Email address" v-model="emailfbn">
                                    </div>
                                    
                                    <div class="form-group">
                                        <label for="phonefbn">Phone number</label>
                                        <input disabled type="text" class="form-control" id="phonefbn" placeholder="Phone number" v-model="phonefbn">
                                    </div>
                                </div>

                                
                            </div>
                            <div class="modal-footer">
                                <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> -->
                                <button type="button" class="btn white-outline-btn" data-dismiss="modal" aria-label="Close" @click="validBvn = false; bvnfbn = ''">
                                    Cancel
                                </button>
                                <button v-if="validBvn" :disabled="loadingCreatAccount" type="button" class="btn primaryBtn" @click="swicthFunctions()">
                                    Create Account
                                    <span v-if="loadingCreatAccount"><i class="fa fa-spinner fa-spin ml-3 f-12"></i></span>
                                </button>
                                <button v-if="!validBvn" :disabled="validateLoader" type="button" class="btn primaryBtn" @click="checkBvnStatusUniversal()">
                                    Verify BVN
                                    <span v-if="validateLoader"><i class="fa fa-spinner fa-spin ml-3 f-12"></i></span>
                                </button>
                            </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div></div>
            </div>
            <SafeWithdrawal></SafeWithdrawal>
        </div>
    </div>
</template>


<script>
// import ApexCharts from "vue3-apexcharts";
// import SmallNav from "./SmallNav";
import { fetchNewLandlordDashboard } from './helpers';
import PageLoader from "./PageLoader.vue";
import moment from "moment";
import SafeWithdrawal from "./SafeWithdrawal"
import { Service } from "../store/service";
const Api = new Service();
import Vue from "vue";
import $ from "jquery";
import VueApexCharts from 'vue-apexcharts'
export default {
    name: "SafeNew",
    components: {
        // SmallNav
        PageLoader,
        apexchart: VueApexCharts,
        SafeWithdrawal,
    },
    data() {
        return {
            switching: false,
            loadingaccount: false,
            loadingaddAccount: false,
            amountVisibility: false,
            pageLoader: false,
            letsvalidate: false,
            pageLoader: false,
            registedForSafe: false,
            loadingCreatAccount: false,
            validBvn: false,
            validateLoader: false,
            activateAddress: false,
            lastnamefbn: "",
            firstnamefbn: "",
            emailfbn: "",
            phonefbn: "",
            bvnfbn: "",
            addressbvn: "",
            fbnReservationId: null,
            safeDetails: {
                balance: 0,
                safedata: '0000000000',
            },
            currentAccountDetails: {},
            whichSafe: "",
            transactions: [],
            bankname: "",
            accountname: "",
            accountnumber: "",
            bankcode: "",
            activeNav: 1,
            currentIndex: 0,
            interval: null,
            switchState: false,
            // banknameandcode: [],
            userAccounts: [],
            bankinfo: '',
            series: [
                { name: 'Debit', data: [] },
                { name: 'Credit', data: [] }
            ],
            chartOptions: {
                chart: { type: 'line', height: 350 },
                stroke: { curve: 'smooth', width: 1 },
                colors: ['#C77F24', '#84EBB4'],
                markers: {
                size: 6,
                shape: 'circle',
                strokeWidth: 2,
                strokeColors: '#fff',
                hover: { size: 8 }
                },
                xaxis: {
                categories: ['Jan', 'Feb', 'Mar', 'April', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
                }
            },
            gtbSwitch: {
                accountNameSwitch: "",
                accountNumberSwitch: "",
                bankNameSwitch: "gtb",
            },
            fbnSwitch: {
                accountNameSwitch: "",
                accountNumberSwitch: "",
                bankNameSwitch: "fbn",
            },
            switchAccountInfo: {
                bank_name: "",
                account_number: ""
            },
            newDasboard: {
                data: {
                    upcoming_tasks: [],
                    number_of_tenants: 0,
                    pending_rent: 0      ,
                    maintenance_requests: 0,
                    projects_count: 0,  
                    today_rewards: 0,
                    shelta_points: 0,
                    percentage_increase: 0,
                    safe_last_funded: {
                        created_at: null
                    }       
                }
            },
            bvndata: {},
            cookiesData: {},
            user: {},
            // formData: "",

            isOpen: false,
            search: "",
            selected: null,
            
            items: [
                "Lagos",
                "Abuja",
                "Port Harcourt",
                "Ibadan",
                "Kano",
                "Enugu",
                "Benin City",
                "Owerri",
                "Uyo",
                "Kaduna",
                "Jos",
                "Ilorin",
            ],

        }
    },
    async created() {
        await this.fetchNewDashboardFunc();
        // await this.createUser();
    },
    computed: {
        filteredItems() {
        return this.banknameandcode.filter((item) =>
            item.bank_name.toLowerCase().includes(this.search.toLowerCase())
        );
        },
    },
    beforeDestroy() {
    },

    mounted() {
        this.fetchbankcodes();
        this.user = JSON.parse(localStorage.getItem("shelta-user"));
        this.recallWebhoookForSafe();
        this.safeCronJob();
        this.fetchSafeData();
        this.fetchUserAccount();
        this.fetchTrasactionChart();
    },

    methods: {

        toggleDropdown() {
            this.isOpen = !this.isOpen;
            this.search = "";
        },
        selectItem(item) {
            this.bankinfo = item;
            this.selected = item.bank_name;
            this.isOpen = false;
        },

        saveCookiesForBvn() {
            // const now = new Date();
            // const time = now.getTime();
            // const expireTime = time + 1000 * 36000;
            // now.setTime(expireTime);
            // document.cookie = "cookie=ok;expires='+now.toUTCString()+';path=/";
            this.cookiesData = this.$cookies.get("_sheltaSafeData");
            const bvndata = {
                fname: this.bvndata.first_name,
                lname: this.bvndata.last_name,
                middleName: this.bvndata.middle_name,
                address: this.bvndata.residential_address,
                phone: this.bvndata.phone_number1,
                dob: this.bvndata.date_of_birth,
                email: this.user.email,
                gender: this.bvndata.gender,
                bvn: this.bvndata.bvn,
            };

            if (this.bvndata.middle_name == "" || this.bvndata.middle_nam == null) {
                bvndata.middleName = "-";
            }
            const date = new Date();
            date.setDate(date.getDate() + 1);
            this.$cookies.set("_sheltaSafeData", bvndata, date);
            this.cookiesData = this.$cookies.get("_sheltaSafeData");
            // console.log("new date", date);
        },

        async checkBvnStatusUniversal() {
            this.validateLoader = true;
            if (this.safeDetails.raw_bvn == null) {
                try {
                await Api.postRequest(`check-if-bvn-exist`, { bvn: this.bvnfbn }).then(res => {
                    // console.log("Bvn check", res);
                    // this.validateLoader = false;
                    if (res.data === true) {
                        this.validateLoader = false;
                        return this.$store.commit("setApiWarning", "BVN Already Exist");
                    }
                    if (res.data === false) {
                        this.bvnCheck();
                    }
                }).catch(err => {
                    console.log("err", err);

                    });
                } finally {
                    // console.log("closed");
                }
            }
            else {
                this.bvnCheck();
            }
        
        },
        async bvnCheck() {
            this.cookiesData = this.$cookies.get("_sheltaSafeData");
            this.validateLoader = true;
            if (this.bvnfbn === '') {
                this.$store.commit("setApiWarning", "Enter Bvn number");
                this.validateLoader = false;
                return;
            }
            // this.decryptData();
            // if (this.bvnfbn == '22222222222') {
            if (this.cookiesData && this.cookiesData.bvn == this.bvnfbn) {
                // this.cookiesData = this.$cookies.get("_sheltaSafeData");
                this.validateLoader = false;
                this.validBvn = true;
                // this.$store.commit("setApiSuccess", "Success");
                this.firstnamefbn = this.cookiesData.fname;
                this.lastnamefbn = this.cookiesData.lname;
                this.emailfbn = this.user.email;
                this.phonefbn = this.cookiesData.phone;
                
                // this.mnamebvn = this.cookiesData.middleName;
                // this.addressbvn = this.cookiesData.address;
                // this.genderbvn = this.cookiesData.gender;
                // this.dobbvn = this.cookiesData.dob;
               
                // this.gender = this.cookiesData.gender;
                if (this.addressbvn == "" || this.addressbvn == null) {
                this.activateAddress = true;
                } else {
                this.activateAddress = false;
                }
            } 
            else {
                try {
                await Api.postRequest(`bvncheckwithdojah`, { bvn: this.bvnfbn })
                    .then(res => {
                    // console.log("New bvn check on init", res);
                    this.validateLoader = false;
                    // this.takeAction = 'bvndetails'
                    if (res.data.success === "success") {
                        // this.$store.commit("setApiSuccess", "Success");
                        this.validBvn = true;
                        this.bvndata = res.data.data;
                        // console.log("bvn data", this.bvndata);
                        this.firstnamefbn = this.bvndata.first_name;
                        this.lastnamefbn = this.bvndata.last_name;
                        this.phonefbn = this.bvndata.phone_number1;
                        this.emailfbn = this.user.email;
                        this.saveCookiesForBvn();

                        // this.gender = this.bvndata.gender;
                        if (
                        this.bvndata.middle_name == "" ||
                        this.bvndata.middle_name == null
                        ) {
                        this.addressbvn = "-";
                        } else {
                        this.mnamebvn = this.bvndata.middle_name;
                        }
                        if (
                        this.bvndata.residential_address == "" ||
                        this.bvndata.residential_address == null
                        ) {
                        this.activateAddress = true;
                        } else {
                        this.activateAddress = false;
                        }
                        // this.encryptData();
                       
                       
                    }
                    if (res.data.error) {
                        this.validBvn = false;
                        if (
                        res.data.error_data ==
                        '{"error":"Your balance is low, pls visit the dashboard to top up"}'
                        ) {
                        this.$store.commit(
                            "setApiFailed",
                            "Can't check BVN now contact Shellta"
                        );
                        }
                        if (res.data.error_data == '{"error":"BVN not found"}') {
                        this.$store.commit("setApiFailed", "BVN not found");
                        } else {
                        this.$store.commit("setApiFailed", res.data.error);
                        }
                    }
                    })
                    .catch(err => {
                    console.log("err", err);
                    this.validBvn = false;
                    this.diableBvnBtn = false;
                    this.validateLoader = false;
                    });
                } finally {
                // console.log(closed);
                }
            }
        },
        recallWebhoookForSafe() {
            Api.getRequest(`requerysquadco`).then(res => {
                // this.fetchSafeData();
                // console.log("requry res", res);
            });
        },
        async fetchNewDashboardFunc() {
            try {
                this.newDasboard = await fetchNewLandlordDashboard();
                // console.log("Landlord Dashboard1", this.newDasboard);
                // if (this.newDasboard.data.success) {
                //     console.log("Landlord Upcoming task", this.newDasboard);
                // }
                
            } catch (error) {
                console.error(error)
            }
        },
        fetchTrasactionChart() {
            Api.getRequest(`safe-graph-data`).then(res => {
                // this.fetchSafeData();
                this.series = [
                    {
                        name: 'Debit',
                        data: res.data.graph.map(({ debit }) => parseFloat(debit))
                    },
                    {
                        name: 'Credit',
                        data: res.data.graph.map(({ credit }) => parseFloat(credit))
                    }
                ];
            });
        },
        safeCronJob() {
            Api.postRequest(`cronjobforsafe`).then(res => {
                // this.fetchSafeData();
                // console.log("requry res", res);
            });
        },
        widthdrawFromSafeTrigger() {
            this.$root.$refs.openConfirm.openConfirmModal();
        },
        afteraction() {
            this.accountnumber = "";
            this.bankinfo = "";
            this.accountname = "";
        },
        openAddAcountModal() {
            $("#addaccount")
            .addClass("fade")
            .modal("show");
        },
        async fetchbankcodes() {
            await Api.getRequest(`fetch-bank-and-codes`)
            .then(data => {
                if (data.data.success) {
                    this.banknameandcode = data.data.data;
                } else {
                    this.$toast.error(data.error);
                }
            }).catch((err) => {
                this.loading = false;
                console.log(err);
                // this.$toast.error("please check your network and refresh the page");
            });
        },
        openAddFBNAcountModal() {
            $("#addaFBNccount")
            .addClass("fade")
            .modal("show");
        },
        async fetchUserAccount() {
            await Api.getRequest(`fetch-user-validated-bank-account`)
            .then(data => {
                // console.log("Account", data)
                if (data.data.success) {
                    this.userAccounts = data.data.banks;
                } else {
                    this.$toast.error(data.error);
                }
            }).catch((err) => {
                this.loading = false;
                console.log(err);
                // this.$toast.error("please check your network and refresh the page");
            });
        },
        async validateAccountNumber() {
        //    console.log("Bank Info", this.bankinfo)
            if (this.accountnumber == '' || this.bankinfo.bank_code == '') {
                return this.$store.commit("setApiFailed", "Fill all required fields");
            }
            this.loadingaccount = true;
            try {
                await Api.postRequest(`fbn-validate-account-number`, {
                    account_number: this.accountnumber,
                    bank_code: this.bankinfo.bank_code
                })
                .then(res => {
                    this.loadingaccount = false;
                    // console.log("Bank details", res);
                    if (res.data.success) {
                        this.accountname = res.data.data.accountName;
                        // this.$store.commit("setApiSuccess", "Account vefiied");
                        this.letsvalidate = true;
                    }
                    if (res.data.error){
                        this.$store.commit("setApiFailed", res.data.error);
                    }
    
                    // this.$store.commit("setApiSuccess", "Success");
                })
                .catch(err => {
                    this.loadingaccount = false;
                    // console.log(err);
                    this.$store.commit("setApiFailed", "An error occured");
                });
            } finally {
                // console.log("Closed connection");
            }
        },
        async addAccountNumber() {
            if (this.accountnumber == '') {
                return this.$store.commit("setApiFailed", "Account number required");
            }
            if (this.bankinfo.bank_code == '') {
                return this.$store.commit("setApiFailed", "Bank code required ");
            }
            if (this.accountname == "") {
                return this.$store.commit("setApiFailed", "Account number required");
            }
            this.loadingaddAccount = true;
            try {
                await Api.postRequest(`save-validated-account-number`, {
                    account_number: this.accountnumber,
                    bank_code: this.bankinfo.bank_code,
                    account_name: this.accountname,
                })
                .then(res => {
                    this.loadingaddAccount = false;
                    // console.log("Added acount", res);
                    if (res.data.success) {
                        // this.accountname = res.data.data.accountName;
                        this.$store.commit("setApiSuccess", "Account Added Successful");
                        this.letsvalidate = false;
                        $("#addaccount")
                        .removeClass("fade")
                        .modal("hide");
                        this.fetchUserAccount();
                        this.validBvn = false;
                    }
                    if (res.data.error){
                        this.$store.commit("setApiFailed", res.data.error);
                        this.validBvn = false;
                    }
    
                    // this.$store.commit("setApiSuccess", "Success");
                })
                .catch(err => {
                    this.loadingaddAccount = false;
                    this.validBvn = false;
                    // console.log(err);
                    this.$store.commit("setApiFailed", "An error occured");
                });
            } finally {
                // console.log("Closed connection");
            }
        },
        swicthFunctions() {
            if (this.fbnReservationId != null) {
                this.fetchFBNbankCode(this.fbnReservationId);
            }
            if (this.fbnReservationId == null) {
                this.createFBNAccount();
            }
        },
        async fetchFBNbankCode(revId) {
            this.loadingCreatAccount = true;
            await Api.getRequest(`get-fbn-account-details-by-reservation-id/${revId}`)
            .then(data => {
                // console.log("Reservation done", data)
                this.loadingCreatAccount = false;
                if (data.data.success) {
                    // this.fbnReservationId = data.data.;
                    $("#addaFBNccount")
                        .removeClass("fade")
                        .modal("hide");
                        this.$store.commit("setApiSuccess", "Account Created Successful");
                    this.fetchSafeData();
                }  
                if (data.data.error) {
                    this.validBvn = false;
                    this.$store.commit("setApiFailed", data.data.error);
                    // this.$toast.error(data.data.error);
                }
            }).catch((err) => {
                this.loadingCreatAccount = false;
                console.log(err);
                this.$store.commit("setApiFailed", err);
                // this.$toast.error(err);
            });
        },
        async createFBNAccount() {
            if (this.firstnamefbn == '' || this.lastnamefbn == '' || this.phonefbn == "" || this.emailfbn == "" || this.bvnfbn == "") {
                return this.$store.commit("setApiFailed", "All fields are required");
            }
            this.loadingCreatAccount = true;
            try {
                await Api.postRequest(`fbn-virtual`, {
            
                    first_name: this.firstnamefbn,
                    last_name: this.lastnamefbn,
                    mobile_num: this.phonefbn,
                    email: this.emailfbn,
                    bvn: this.bvnfbn,

                })
                .then(res => {
                    this.loadingCreatAccount = false;
                    // console.log("Create first bank account", res);
                    if (res.data.success) {
                        // this.accountname = res.data.data.accountName;
                        this.letsvalidate = false;
                        this.fbnReservationId = res.data.reservation_id;
                        this.fetchFBNbankCode(res.data.reservation_id)
                        // $("#addaFBNccount")
                        // .removeClass("fade")
                        // .modal("hide");
                        
                    }
                    if (res.data.error){
                        this.$store.commit("setApiFailed", res.data.error);
                    }
    
                    // this.$store.commit("setApiSuccess", "Success");
                })
                .catch(err => {
                    this.loadingCreatAccount = false;
                    // console.log(err);
                    this.$store.commit("setApiFailed", "An error occured");
                });
            } finally {
                // console.log("Closed connection");
            }
        },
        async switchAccount() {
            // this.formData = new FormData();
            let payloadObject = null;
            this.switching = true;
            let payload = {
                account_name: this.gtbSwitch.accountNameSwitch,
                account_number: this.gtbSwitch.accountNumberSwitch,
                bank_name: this.gtbSwitch.bankNameSwitch,
            }
            let payload2 =  {
                account_name: this.fbnSwitch.accountNameSwitch,
                account_number: this.fbnSwitch.accountNumberSwitch,
                bank_name: this.fbnSwitch.bankNameSwitch,
            }
            if (this.switchState == false) {
                payloadObject = payload;

                // this.formData.append("account_name", this.gtbSwitch.accountNameSwitch);
                // this.formData.append("account_number", this.gtbSwitch.accountNumberSwitch);
                // this.formData.append("bank_name", this.gtbSwitch.bankNameSwitch);
            }
            else if (this.switchState == true) {
                payloadObject = payload2;
                // console.log("FBN CHECK")

                // this.formData.append("account_name", this.fbnSwitch.accountNameSwitch);
                // this.formData.append("account_number", this.fbnSwitch.accountNumberSwitch);
                // this.formData.append("bank_name", this.fbnSwitch.bankNameSwitch);
            }
            try {
                await await Api.postRequest(`save-current-safe-account-number`, payloadObject).then(res => {
                    this.switching = false;
                    if (res.data) {
                        this.fetchSafeData();
                    }
                }).catch(err => {
                    this.switching = false;
                    // console.log(err);
                    this.$store.commit("setApiFailed", "An error occured");
                });
            } finally {
                // console.log("closed");
            }
        },
       
        async fetchSafeData() {
            this.pageLoader = true;
            try {
                await Api.getRequest(`fetchsafedata`)
                .then(res => {
                    // console.log("safe data", res);
                    this.pageLoader = false;
                    if (res.data.success) {
                    this.safeDetails = res.data;
                    this.currentAccountDetails = JSON.parse(res.data.safedata.current_account);
                    let thelastname =  res.data.safedata.last_name.split('-');
                    this.safeDetails.safedata.lname = thelastname[0];
                    // this.firstnamefbn = this.safeDetails.safedata.first_name;
                    // this.lastnamefbn = this.safeDetails.safedata.lname;
                    // this.phonefbn = this.safeDetails.safedata.mobile_num;
                    // this.emailfbn = this.safeDetails.safedata.email;

                    if (res.data.safedata != null) {
                        this.fbnReservationId = res.data.safedata.reservationId;
                        this.gtbSwitch.accountNumberSwitch = res.data.safedata.squadaccountno;
                        this.gtbSwitch.accountNameSwitch = res.data.safedata.last_name;
                        this.fbnSwitch.accountNumberSwitch = res.data.safedata.firstBankaccountNumber;
                        this.fbnSwitch.accountNameSwitch = res.data.safedata.first_bank_account_name;
                        // if (res.data.safedata.squadaccountno != null && (res.data.safedata.firstBankaccountNumber == null || res.data.safedata.firstBankaccountNumber != null) &&  res.data.safedata.current_account == null) {
                        //     // res.data.safedata.current_account.account_number = res.data.safedata.squadaccountno
                        //     if (res.data.safedata.current_account != null) {
                        //         let x = JSON.parse(res.data?.safedata.current_account);
                        //         x.account_number = res.data?.safedata.squadaccountno;
                        //         this.switchAccountInfo = x;
                        //     }
                        // } 
                        // if (res.data.safedata.firstBankaccountNumber != null && res.data.safedata.squadaccountno == null && res.data.safedata.current_account == null) {
                        //     // res.data.safedata.current_account.account_number = res.data.safedata.firstBankaccountNumber 
                        //     if (res.data.safedata.current_account != null) {
                        //         let y = JSON.parse(res.data?.safedata.current_account);
                        //         y.account_number = res.data?.safedata.firstBankaccountNumber;
                        //         this.switchAccountInfo = y
                        //     };
                        // }
                        // else {
                        //     let z = JSON.parse(res.data.safedata.current_account);
                        //     this.switchAccountInfo = z;
                        // }
                        if (this.safeDetails.safedata.firstBankaccountNumber === this.currentAccountDetails?.account_number) {
                            this.switchState = true;
                
                        }   
                        if (this.safeDetails.safedata.squadaccountno === this.currentAccountDetails?.account_number) {
                            this.switchState = false;
                           
                        }
                        this.registedForSafe = true;
                        
                        // this.transactions = this.$store.value.data.transactions;
                        this.transactions = res.data.transactions;
                        if (res.data.safedata.bvn != null) {
                        this.registedForSafe = true;
                        this.whichSafe = "yellowSafe";
                        } else {
                        this.whichSafe = "blueSafe";
                        // this.registedForSafe = false;
                        this.registedForSafe = true;
                        }
                    } else {
                        this.registedForSafe = false;
                    }

                    // if (res.data.safedata.bvn == null) {
                    //   this.whichSafe = "blueSafe";
                    //   // this.registedForSafe = false;
                    //   this.registedForSafe = true;
                    // }
                    }
                    if (res.data.error) {
                    this.$store.commit("setApiFailed", "Can not read account");
                    }
                })
                .catch(err => {
                    this.pageLoader = false;
                    console.log(err);
                    if (err == "Error: Network Error") {
                    this.registedForSafe = "";
                    }
                    // this.loader = false;
                    // this.uploading = true;
                });
            } finally {
                // console.log("Closed connection");
            }
        },  
        copyAccountNumber(value) {
            navigator.clipboard.writeText(value)
            .then(() => {
                this.$store.commit("setApiSuccess", `Copied ${value}`);
            })
            .catch(err => {
                console.error('Failed to copy: ', err)
            })
        },
    },
    filters: {
    moment: function(date) {
      return moment(date).format("MMMM Do YYYY, h:mm:ss a");
    },
    moment2: function(date) {
        return moment(date).format("MMMM Do YYYY");
    },
    moment3: function(date) {
        return moment(date).format("h:mm:ss a");
    },
  }
    
}
</script>


<style scoped lang="scss">

.top-control {
    text-align: left;
    margin-top: 30px;
    margin-bottom: 40px;
    button {
        font-family: Lato;
        font-weight: 700;
        font-size: 14px;
        line-height: 160%;
        color: #4B5563;
        outline: 0;
        box-shadow: none;
    }
    // button:first-child {
    //     padding-left: 0;
    // }
}
.active-control {
    border-bottom: 4px solid #0033EA;
    border-radius: 0;
}

.safe-card {
    padding: 16px 25px;
    background: #ffffff;
    border-radius: 12px;
    min-height: 261px;
}

.safe-card-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    h3 {
        font-family: Lato;
        font-weight: 700;
        font-size: 20px;
        line-height: 160%;
        color: #00155F;
        margin-bottom: 0;
    }
}

.af {
    font-family: Lato;
    font-weight: 500;
    font-size: 15px;
    line-height: 160%;
    color: #374151;
    text-align: left;
    margin-top: 10px;
}

.safe-amount {
    display: flex;
    justify-content: space-between;
    h3, .naira {
        font-family: Lato;
        font-weight: 700;
        font-size: 22px;
        line-height: 32px;
        color: #374151;
        text-align: left;
        span {
            // color: #2BC300;
            font-family: Lato;
            font-weight: 500;
            font-size: 18px;
            line-height: 150%;
            margin-left: 7px;
            cursor: pointer;
        }
    }
    .increase-figure {
        color: #2BC300;
        font-family: Lato;
        font-weight: 500;
        font-size: 12px;
        line-height: 150%;
        // margin-left: 7px;
        cursor: pointer;
        text-align: left;
        margin-bottom: 10px;
    }
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 11px;
        line-height: 150%;
        color: #555C74;
        text-align: left;
        margin-bottom: 5px;
    }
}

.triggerWithdraw {
    font-family:Lato;
    font-weight: 600;
    font-style: SemiBold;
    font-size: 12px;
    line-height: 160%;
    text-decoration: underline;
    cursor: pointer;
}

.account-number {
    display: flex;
    gap: 5px;
    text-align: left;
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 11px;
        // line-height: 22.25px;
        color: #374151;
        margin-bottom: 0;
    }
    h5 {
        font-family: Lato;
        font-weight: 600;
        font-size: 14px;
        line-height: 22.25px;
        color: #374151;
        margin-bottom: 0;
    }
}
.bank-details {
    display: flex;
    justify-content: space-between;
}
.white-outline-btn {
    border: 1px solid #D2D2D2;
    background: #ffffff;
    font-family: Lato;
    font-weight: 600;
    font-size: 12px;
    color: #333333;
    outline: 0;
    box-shadow: 0;
}

.primaryBtn {
    background: #0033EA;
    font-family: Lato;
    font-weight: 600;
    font-size: 12px;
    color: #ffffff;
    outline: 0;
    box-shadow: none;
}

.chart-headersss {
    font-family: Lato;
    font-weight: 600;
    font-size: 16.85px;
    line-height: 26.95px;
    color: #2B3352;
    // margin-bottom: 20px;
    text-align: left;
}

.table-holder {
    background: #ffffff;
    padding: 30px 15px;
    margin-top: 30px;
}
.t-history {
    font-family: Lato;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    color: #2B3352;
    text-align: left;
    margin-bottom: 20px;
}


.tableList {
    // margin-top: 30px;
    margin-bottom: 20px;
    border: 2px solid #EAECF0;
    border-radius: 8px;
}


.table thead th {
    border-bottom: none;
    
}
.table td {
    border-top: 1px solid #EAECF0;
}
.table th {
    border-top: none;
}

thead > tr {
    background: #F3F4F6;
}
thead th {
    white-space: nowrap;
    text-align: left;
    color: #374151;
    font-family: Lato;
    font-weight: 700;
    font-size: 14px;
    line-height: 160%;
}

tbody td {
    padding: 18px .75rem;
    white-space: nowrap;
    font-family: Lato;
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    color: #374151;
    line-height: 24px;
}

tbody {
    tr {
        cursor: pointer;
    }
}

.credit {
    background: #84EBB4;
    border-radius: 50px;
    color: #374151;
    padding: 2px 10px;
    font-size: 12px;
    text-transform: capitalize;
}
.debit {
    background: #DFA052;
    border-radius: 50px;
    color: #333333;
    padding: 2px 10px;
    font-size: 12px;
    text-transform: capitalize;
}

.swicthbank-text {
    font-family: Lato;
    font-weight: 600;
    font-size: 10px;
    line-height: 160%;
    color: #333333;
    display: flex;
    span {
        margin-right: 3px;
    }
}

#customSwitch1 {
    cursor: pointer;
}
.custom-control-label::before {
    outline: 0 !important;
    box-shadow: none !important;
    cursor: pointer;
}

.withdrawal-account-section {
    background: #ffffff;
    padding: 15px;
    margin-bottom: 30px;
    h6 {
        font-family: Lato;
        font-weight: 700;
        font-size: 18px;
        line-height: 160%;
        color: #333333;
        text-align: left;
    }
}

.bank-addition {
    text-align: right;
    button {
        background: #00155F;
        font-family: Lato;
        font-weight: 600;
        // font-size: 16px;
        color: #ffffff;
        outline: 0;
        box-shadow: none;
    }
}

.account-holder {
    background: #EAF0F0;
    padding: 10px 16px 10px;
    margin-bottom: 10px;
    h4 {
        font-weight: 600;
        font-style: SemiBold;
        font-size: 16px;
        line-height: 160%;
        color: #333333;
        text-align: left;
    }
    h5 {
        font-family: Lato;
        font-weight: 400;
        font-style: Regular;
        font-size: 14px;
        line-height: 20px;
        color: #555C74;
        text-align: left;
    }
}

.form-group {
    label {
        font-family: Lato;
        font-weight: 500;
        font-size: 14px;
        line-height: 150%;
        color: #777777;
        text-align: left;
        display: flex;
    }
    input, select {
        border: 1px solid #BBBBBB;
        // color: #D1DBFF1A;
        height: 45px;
        color: #333333;
        font-family: Lato;
        font-weight: 600;
        font-size: 12px;
        box-shadow: none;
        outline: 0;
    }
}

.modal-header  {
    border-bottom: none;
}
.modal-footer {
    border-top: none;
}

.primaryBtn {
    background: #0033EA;
    font-family: Lato;
    font-weight: 600;
    font-size: 12px;
    color: #ffffff;
    outline: 0;
    box-shadow: none;
}

.white-outline-btn {
    border: 1px solid #D2D2D2;
    background: #ffffff;
    font-family: Lato;
    font-weight: 600;
    font-size: 12px;
    color: #333333;
    outline: 0;
    box-shadow: none;
}

// Empty state
.empty-state {
    h5 {
        font-family: Lato;
        font-weight: 700;
        font-size: 13.95px;
        line-height: 21.7px;
        letter-spacing: 0%;
        text-align: center;
        color: #777777;

    }
}
// empty state

/* For WebKit browsers (Chrome, Safari, Edge) */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* For Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

input:disabled {
    background: transparent !important;
    cursor: not-allowed;
}



// Filter starts here
.dropdownn {
  width: 100%;
  position: relative;
  font-family: Lato;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
}
.dropdown-togglee {
  padding: 10px;
  cursor: pointer;
  border: 1px solid #BBBBBB !important;
  border-radius: 4px solid !important;
  height: 48px !important;
  font-weight: 400 !important;
  color: 333333 !important;
  outline: 0 !important;
  box-shadow: none !important;
}
.dropdown-menuu {
  position: absolute;
  width: 100%;
  margin-top: 4px;
  border: 1px solid #ddd;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  font-family: Lato;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
}
.dropdown-search {
  width: 100%;
  padding: 8px;
  border: none;
  border-bottom: 1px solid #ddd;
  outline: none;
}
.dropdown-list {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 200px;
  overflow-y: auto;
}
.dropdown-item {
  padding: 10px;
  cursor: pointer;
  font-family: Lato;
  font-size: 12px;
  font-weight: 600;
}
.dropdown-item:hover {
  background: #f4f4f4;
}
.no-results {
  padding: 10px;
  color: #888;
  font-style: italic;
}
// Filter ends here
</style>